export type PlayerRowStats = {
  rank: number;
  callsign: string;
  attendance: number;
  frags: number;
  tk: number;
  survival: number;
  medic: number;
  ego: number;
  efficiency: number;
};

export type PlayerRow = PlayerRowStats & {
  delta?: number | null;
  recordType?: string | null;
};

export type PlayerColumnKey = keyof PlayerRowStats;

export type PlayerColumn = {
  key: PlayerColumnKey;
  label: string;
  type: 'number' | 'string';
};

export const playerColumns: PlayerColumn[] = [
  { key: 'rank', label: 'Рейтинг', type: 'number' },
  { key: 'callsign', label: 'Позывной', type: 'string' },
  { key: 'attendance', label: 'Посещаемость', type: 'number' },
  { key: 'frags', label: 'Фраги', type: 'number' },
  { key: 'tk', label: 'ТК', type: 'number' },
  { key: 'survival', label: 'Выживаемость', type: 'number' },
  { key: 'medic', label: 'Медицина', type: 'number' },
  { key: 'ego', label: 'ЧСВ', type: 'number' },
  { key: 'efficiency', label: 'КПД', type: 'number' },
];

export const defaultSort: { key: PlayerColumnKey; direction: 'asc' | 'desc' } = {
  key: 'efficiency',
  direction: 'desc',
};
